import { render } from "./PaymentTimer.vue?vue&type=template&id=422ebb90"
import script from "./PaymentTimer.vue?vue&type=script&lang=js"
export * from "./PaymentTimer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__